import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';

import { DialogService } from '../../../../shared/services/dialog.service';
import { DialogComponent } from '../../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../../components/form/label/label.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Utility } from '../../../../common/utility';
import { AppConstants } from '../../../../shared/constants/constants';
import { AppMessages } from '../../../../shared/constants/messages';
import { ValidationService } from '../../../../shared/services/validation.service';

import { Page } from '../../../../models/list/page.model';
import { IndividualWaitingModel } from '../../../../models/waiting-room/individual-waiting.model';
import { GroupTemplateService } from './group-template.service';
import { GroupWaitingModel } from '../../../../models/waiting-room/group-waiting.model';
import * as moment from 'moment';

@Component({
  selector: 'modify-group-template-popup',
  templateUrl: 'modify-group-template-popup.component.html',
  providers: [GroupTemplateService]
})
export class ModifyGroupTemplateComponent implements OnInit {
  @ViewChild('fileAttach') fileAttachVariable: any;

  public addPatientForm: FormGroup;
  public groupForm: FormGroup;
  public title = '';
  public page = new Page(); // for patient
  public pageAttachment = new Page();
  public dataRow = new Array<IndividualWaitingModel>();
  public dataListPatientAdd = new Array<any>();
  public groupTemplateModel = new GroupWaitingModel();
  public countryId = null;

  public dataMessage = {
    emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
    totalMessage: AppMessages.list.total
  };
  public appConstants = AppConstants;
  public customClasses = AppConstants.table.footerClasses;
  public isCreateSuccess = false;
  public dataPaymentTerm = [];

  // for attachment file
  public attachmentRow = [];
  public listFileExisted = [];
  public listFileUpload = [];
  public attachmentFile: File = null;
  public formDataAttachment = new FormData();

  constructor(
    public utility: Utility,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public groupTemplateService: GroupTemplateService,
    public dialogRef: MdDialogRef<ModifyGroupTemplateComponent>,
    @Inject(MD_DIALOG_DATA) public data: {
      groupId: string,
      countryId: string,
      countries: Array<any>
    }
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.page.size = 5;
    this.pageAttachment.size = 5;
    this.initPaymentTemp();
    if (this.data.groupId) {
      this.title = 'Update';
      this.setPagePatient({ offset: 0 });
      this.initSelectPatientList();
      this.initGroupData();
    } else {
      this.title = 'Create';
      this.groupTemplateModel.countryId = this.data.countryId; // get countryId from father

    }
  }

  /**
   * Set page for patient list
   * @param pageInfo
   */
  setPagePatient(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1
    };

    // call API to get patient
    this.groupTemplateService.getGroupMemberList(this.data.groupId, param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.dataRow = data['list'];
          this.page.totalElements = data['totalRecords'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          this.groupForm.controls['patientMembers'].setValue(this.dataRow);
        }
      }
    );
  }

  /**
 * Set page for attachment list
 * @param pageInfo
 */
  setAttachmentPage(pageInfo) {
    this.pageAttachment.pageNumber = pageInfo.offset;
    // List file existed
    this.attachmentRow = this.listFileExisted;
    this.pageAttachment.totalElements = this.attachmentRow.length;
    this.pageAttachment.totalPages = Math.ceil(this.pageAttachment.totalElements / this.page.size);

  }


  createForm() {
    this.groupForm = this.formBuilder.group({
      groupName: ['', [Validators.required, ValidationService.isSpecialCharacters]],
      contact: ['', [Validators.required, ValidationService.isSpecialCharacters]],
      address: ['', [Validators.required]],
      email: ['', [Validators.required, ValidationService.isValidEmail]],
      phone: ['', [Validators.required]],
      countryId: [''],
      description: '',
      patientMembers: [this.dataRow],
      paymentTerm: [null, [Validators.required]],
      isGroupTemplate: [true],
      fileAttachments: [''],
      departureDate: [''],
      departureDateDisplay: [''],
    });

    // create form for select add patient
    this.addPatientForm = this.formBuilder.group({
      patientId: [null, [Validators.required]]
    });

  }

  /**
   * Init list patient for select add patient
   */
  initSelectPatientList() {
    // call API to get data
    this.groupTemplateService.getPatientAddList().subscribe(
      (result) => {
        const data = result.json();
        this.dataListPatientAdd = data;
        // remove patient who is exist in selected patient array
        this.groupTemplateService.addPatientToTable(this.dataRow, this.dataListPatientAdd);
      }
    );
  }

  /**
   * Init Group data when edit group
   */
  initGroupData() {
    // call API to get data
    const groupId = this.data.groupId;
    this.groupTemplateService.getGroupTemplateDetail(groupId).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.groupTemplateModel = data;

          if (this.groupTemplateModel.departureDate) {
            this.groupForm.controls['departureDateDisplay'].setValue(moment(this.groupTemplateModel.departureDate).format(AppConstants.dateConfig.date));
          }

          if (this.groupTemplateModel.fileAttachments) {
            // List file exist
            this.listFileExisted = this.groupTemplateModel.fileAttachments;
            // set attachment row when listFileExisted have
            this.setAttachmentPage({ offset: 0 });
          }
        }
      }
    );
  }

  /**
   * Init Payment Temp data
   */
  initPaymentTemp() {
    this.groupTemplateService.getDataPaymentTerm().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.dataPaymentTerm = data;
          // Display list of options in specific order “Group 15 day credit”, “Group members paying individually”
          this.dataPaymentTerm.splice(this.dataPaymentTerm.indexOf('30 days from invoices date'), 1);
        }
      }
    );
  }

  onCloseDialog() {
    this.dialogRef.close(this.isCreateSuccess);
  }

  onDepartureDateChange(dateText) {
    //ValidationService.validationDate(this.patientInformationForm.controls['birthDay'], dateText);
    const dateOfBirth = this.utility.convertDateToString(this.groupForm.controls['departureDateDisplay'].value);
    this.groupForm.controls['departureDate'].setValue(dateOfBirth);
}



  onSubmit() {

    this.listFileUpload.forEach(element => {
      this.formDataAttachment.append('uploadFileList', element.file, element.fileName);
    });
    // set data upload file exist
    this.groupForm.controls['fileAttachments'].setValue(this.listFileExisted);
    if (this.groupForm.valid) {

      if (this.groupForm.controls['countryId'].value === 'null') {
        this.groupForm.controls['countryId'].setValue('');
      }

      this.formDataAttachment.append('data', JSON.stringify(this.groupForm.value));
      // Update group

      if (this.data.groupId) {
        this.groupTemplateService.updateGroupTemplate(this.data.groupId, this.formDataAttachment).subscribe(
          (result) => {
            if (result) {
              const data = result.json();
              this.isCreateSuccess = true;
              this.onCloseDialog();
              // open success popup
              this.dialogService.openSuccessDialog({
                message: data.message
              });
            }
          }, error => {
            this.formDataAttachment.delete('uploadFileList');
            this.formDataAttachment.delete('data');
            if (this.groupForm.controls['countryId'].value === '') {
              this.groupForm.controls['countryId'].setValue('null');
            }
          }
        );
      } else {
        // Create group
        this.groupTemplateService.createGroupTemplate(this.formDataAttachment).subscribe(
          (result) => {
            if (result) {
              const data = result.json();
              this.isCreateSuccess = true;
              this.onCloseDialog();
              // open success popup
              this.dialogService.openSuccessDialog({
                message: data.message
              });
            }
          }, error => {
            this.formDataAttachment.delete('uploadFileList');
            this.formDataAttachment.delete('data');
            if (this.groupForm.controls['countryId'].value === '') {
              this.groupForm.controls['countryId'].setValue('null');
            }
          }
        );
      }

    }
  }

  /**
   * Add patient to list patient
   */
  onAddPatientToGroup() {
    this.addPatientForm.controls['patientId'].markAsTouched();
    const patientId = this.addPatientForm.controls['patientId'].value;
    // no patient is selected
    if (patientId !== 'null' && patientId !== undefined && patientId !== null && this.addPatientForm.controls['patientId'].valid) {

      // API add patient to group template
      this.groupTemplateService.addPatientToGroupTemplate(this.data.groupId, patientId).subscribe(
        result => {
          if (result) {
            const patientItem = this.dataListPatientAdd.filter(c => c.id === patientId);
            // add patient to patient array
            this.dataRow.push(patientItem[0]);
            // remove patient from select box
            this.groupTemplateService.addPatientToTable([patientItem[0]], this.dataListPatientAdd);
            this.page.totalElements += 1;

            // set patientId null when add success
            this.addPatientForm.controls['patientId'].setValue(null);
            this.addPatientForm.controls['patientId'].markAsUntouched();
          }
        }
      );
    }
  }

  /**
   * Remove patient from list patient
   */
  onRemovePatientFromGroup(userId) {
    const data = {
      message: AppMessages.groupConsultant.removeUserFromCreateGroup,
    };
    this.dialogService.openConfirmationDialog(data).subscribe(result => {
      if (result) {
        // API remove patient to group template
        this.groupTemplateService.removePatientFromGroupTemplate(this.data.groupId, userId).subscribe(
          deleteResult => {
            if (deleteResult) {
              this.setPagePatient({ offset: 0 });
              this.groupTemplateService.removePatientFromTable(this.dataRow, this.dataListPatientAdd, userId);
            }
          });
      }
    });
  }

  onChangeAttachment(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      // Show error dialog when file > 2MB
      if (this.utility.isValidFile(file, ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "jpg", "png"], 2)) {
        this.attachmentFile = file;
      } else {
        this.dialogService.openErrorDialog({ message: AppMessages.errors.invalidDocFile });
      }
    }
  }

  onUploadAttachment() {
    if (this.attachmentFile) {
      // push file to list file
      this.listFileUpload.push({
        id: this.listFileUpload.length,
        file: this.attachmentFile,
        fileName: this.attachmentFile.name,
        uploadDateTime: this.utility.convertDateToLocalString(new Date()),
      });

      // refresh list
      this.attachmentRow = this.listFileExisted.concat(this.listFileUpload);
      this.pageAttachment.totalElements++;
      this.attachmentFile = null;
    }
  }

  removeAttachment(event, row) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.groupTemplateConsultant.removeAttachment }).subscribe(result => {
      if (result) {
        // remove file in list
        const indexExistedFile = this.listFileExisted.indexOf(row);
        if (indexExistedFile >= 0) {
          this.listFileExisted.splice(indexExistedFile, 1);
        } else {
          const indexFileUpload = this.listFileUpload.indexOf(row);
          this.listFileUpload.splice(indexFileUpload, 1);
        }
        // get input file and set value to null
        this.attachmentFile = null;
        this.fileAttachVariable.nativeElement.value = '';
        // update attachment list
        this.attachmentRow = this.listFileExisted.concat(this.listFileUpload);
        this.pageAttachment.totalElements--;
        this.pageAttachment.totalPages = Math.ceil(this.pageAttachment.totalElements / this.pageAttachment.size);
        if ((this.pageAttachment.pageNumber + 1) > this.pageAttachment.totalPages) {
          this.pageAttachment.pageNumber = this.pageAttachment.totalPages - 1;
        }
      }
    });
  }

  setAttactmentCurrentPage(pageInfo) {
    this.pageAttachment.pageNumber = pageInfo.offset;
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/modify-group-template-popup.component.ts